import React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/system";

const StyledTextField = styled(TextField)({
  display: "flex",
  alignItems: "left-align",
  width: "100%",
  "& label.Mui-focused": {
    color: "black",
  },
  "& .MuiOutlinedInput-root": {
    "& .MuiOutlinedInput-input": {
      padding: "10px 12px",
      color: "black",
      width: "100%",
      backgroundColor: "#ffffff",
    },
  },
});

const Textfield = (props) => {
  const {
    id,
    name,
    label,
    placeholder,
    type,
    variant = "outlined",
    value,
    handleOnChange: onChange,
    onBlur,
    error,
    helperText,
    disabled,
    multiline,
    minRows,
    inputProps,
    InputProps,
    className,
  } = props;

  return (
    <StyledTextField
      id={id}
      name={name}
      label={label}
      placeholder={placeholder}
      type={type}
      variant={variant}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      disabled={disabled}
      multiline={multiline}
      minRows={minRows}
      slotProps={{
        htmlInput: {
          ...inputProps,
          ...InputProps,
        },
      }}
      className={className}
      fullWidth
    />
  );
};

export default Textfield;
